/**
 * @fileoverview API helpers to update cost linking requirement for payments.
 * @module features/payments/api/linkingRequirementService
 */

import apiClient from '@/lib/apiClient'

export type CostLinkingRequirement = 'REQUIRED' | 'NOT_NEEDED' | 'OPTIONAL'

export async function updatePaymentLinkingRequirement(
  paymentUuid: string,
  requirement: CostLinkingRequirement
): Promise<void> {
  await apiClient.patch(
    `/universal-transactions/${encodeURIComponent(paymentUuid)}/linking-requirement`,
    {
      costLinkingRequirement: requirement,
    }
  )
}

export async function batchUpdatePaymentLinkingRequirement(
  paymentUuids: string[],
  requirement: CostLinkingRequirement
): Promise<void> {
  await apiClient.patch(`/universal-transactions/linking-requirement/batch`, {
    paymentUuids,
    costLinkingRequirement: requirement,
  })
}

export default {
  updatePaymentLinkingRequirement,
  batchUpdatePaymentLinkingRequirement,
}
